import { parseQuery } from "utils/parseQuery"

/**
 * The Home page (wizard CTA, live "Add more product", live "Add category")
 * opens the product editors directly. Those editors normally exit to their
 * list page — but a merchant who came from Home must land back on Home
 * (Asana 1217219117645798, 1217264633252428).
 *
 * `withFromHome(target)` marks the editor URL when leaving Home;
 * `isFromHome(search)` lets the editor resolve its exit URL to /home.
 * The marker must be re-carried across editor-internal re-navigations
 * (e.g. the glasses draft URL swap), same as withListPage's ?page.
 */
export const FROM_HOME_PARAM = "from"
export const FROM_HOME_VALUE = "home"

export const withFromHome = (target: string): string =>
  `${target}${target.includes("?") ? "&" : "?"}${FROM_HOME_PARAM}=${FROM_HOME_VALUE}`

export const isFromHome = (search: string): boolean =>
  parseQuery(search)[FROM_HOME_PARAM] === FROM_HOME_VALUE
